import { useState, useEffect } from 'react';
import LegalLayout from './LegalLayout';

function PoliticaCookies() {
  const [html, setHtml] = useState<string | null>(null);
  const [css, setCss] = useState('');

  useEffect(() => {
    fetch('/api/conteudo/pagina/cookies')
      .then((res) => {
        if (!res.ok) throw new Error();
        return res.json();
      })
      .then((data) => {
        if (data.html && data.html.trim()) {
          setHtml(data.html);
          setCss(data.css || '');
        }
      })
      .catch(() => {});
  }, []);

  if (html) {
    return (
      <LegalLayout>
        <style dangerouslySetInnerHTML={{ __html: css }} />
        <div dangerouslySetInnerHTML={{ __html: html }} />
      </LegalLayout>
    );
  }

  return (
    <LegalLayout>
      <h1>Política de Cookies</h1>
      <p className="legal-last-updated">Última atualização: Janeiro de 2025</p>

      <p>
        Esta política explica como a <strong>Vavassori Designer</strong> utiliza cookies em sua
        plataforma de acompanhamento de obras.
      </p>

      <h2>1. O que são Cookies?</h2>
      <p>
        Cookies são pequenos arquivos de texto armazenados no seu navegador quando você acessa um
        site. Eles são amplamente utilizados para fazer sites funcionarem de maneira mais eficiente
        e fornecer informações aos proprietários do site.
      </p>

      <h2>2. Cookies que Utilizamos</h2>

      <h3>2.1 Cookies Essenciais (Obrigatórios)</h3>
      <p>
        Estes cookies são necessários para o funcionamento básico da plataforma. Sem eles, o
        sistema não pode operar corretamente.
      </p>
      <ul>
        <li>
          <strong>Token de autenticação:</strong> mantém sua sessão ativa enquanto você utiliza a
          plataforma, garantindo acesso seguro às suas informações
        </li>
        <li>
          <strong>Cookie de sessão:</strong> identifica sua sessão de navegação e garante a
          segurança das operações realizadas
        </li>
        <li>
          <strong>Preferências de interface:</strong> armazena configurações básicas como idioma e
          tema, para melhor experiência de uso
        </li>
      </ul>

      <h3>2.2 Cookies de Desempenho</h3>
      <p>
        Utilizamos cookies mínimos para monitorar o desempenho da plataforma e identificar
        possíveis problemas técnicos. Esses dados são anônimos e utilizados exclusivamente para
        melhoria do serviço.
      </p>

      <h3>2.3 Cookies de Publicidade</h3>
      <p>
        <strong>Não utilizamos cookies de publicidade ou rastreamento.</strong> Nossa plataforma
        não exibe anúncios e não compartilha dados de navegação com redes de publicidade ou
        plataformas de marketing.
      </p>

      <h2>3. Duração dos Cookies</h2>
      <ul>
        <li>
          <strong>Cookies de sessão:</strong> expiram quando você fecha o navegador
        </li>
        <li>
          <strong>Token de autenticação:</strong> expira após o período de validade configurado
          (geralmente 24 horas de inatividade)
        </li>
        <li>
          <strong>Preferências:</strong> mantidas por até 1 ano para conveniência
        </li>
      </ul>

      <h2>4. Como Gerenciar Cookies</h2>
      <p>
        Você pode controlar e gerenciar cookies através das configurações do seu navegador. A
        maioria dos navegadores permite:
      </p>
      <ul>
        <li>Visualizar quais cookies estão armazenados</li>
        <li>Excluir cookies individualmente ou todos de uma vez</li>
        <li>Bloquear cookies de terceiros</li>
        <li>Bloquear todos os cookies (pode impedir o funcionamento da plataforma)</li>
        <li>Configurar notificações quando um cookie é definido</li>
      </ul>

      <h3>Instruções por Navegador</h3>
      <ul>
        <li>
          <strong>Google Chrome:</strong> Configurações → Privacidade e segurança → Cookies e
          outros dados do site
        </li>
        <li>
          <strong>Firefox:</strong> Configurações → Privacidade e Segurança → Cookies e dados de
          sites
        </li>
        <li>
          <strong>Safari:</strong> Preferências → Privacidade → Gerenciar dados de sites
        </li>
        <li>
          <strong>Microsoft Edge:</strong> Configurações → Cookies e permissões de site
        </li>
      </ul>

      <p>
        <strong>Atenção:</strong> desabilitar cookies essenciais impedirá o funcionamento adequado
        da plataforma, incluindo o login e o acesso aos dados dos projetos.
      </p>

      <h2>5. Alterações nesta Política</h2>
      <p>
        Podemos atualizar esta política de cookies periodicamente. Quaisquer alterações serão
        publicadas nesta página com a data de atualização revisada.
      </p>

      <h2>6. Contato</h2>
      <p>Para dúvidas sobre o uso de cookies em nossa plataforma, entre em contato:</p>
      <p>
        <strong>E-mail:</strong>{' '}
        <a href="mailto:privacidade@vavassoridesigner.com.br">
          privacidade@vavassoridesigner.com.br
        </a>
      </p>
    </LegalLayout>
  );
}

export default PoliticaCookies;
